export const colorPalet = {
  // Primary Colors
  primary: "#000000",
  secondary: "#ffffff",

  // Brand Colors
  brandPrimary: "#003091",
  brandBlue: "#159ef0",
  brandGreen: "#52c41a",

  // Text Colors
  textPrimary: "#000000",
  textSecondary: "#262626",
  textTertiary: "#595959",
  textMuted: "#8c8c8c",
  textLight: "#666",

  // Background Colors
  backgroundPrimary: "#f5f7fa",
  backgroundSecondary: "#fafafa",
  backgroundLight: "#ffffff",

  // Border Colors
  borderPrimary: "#d9d9d9",
  borderLight: "#e5e7eb",
  borderDivider: "#f0f0f0",

  // Status Colors
  success: "#52c41a",
  warning: "#faad14",
  error: "#F5222D",
  hover: "#003bb345",

  //tooltip
  tooltipBackground: "#eceff1",
  chartLine: "#BFBFBF",

  // New Colors from constants.js
  tykrFairValue: "#003BB3",
  tykrFairValueLight: "#C7D9FF",
  rule1FairValue: "#FAAD14",
  rule1FairValueLight: "#FFF1B8",
  grahamFairValue: "#9E1068",
  grahamFairValueLight: "#FFD6E7",
};
